import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Response from "../../../model/Response";
import Article from "../../../entities/Article";
import { ArticleStockService } from "../../../service/articleDelivery/ArticleStockService";
import AddArticleDeliveryStockRequest from "../../../model/articleDelivery/AddArticleDeliveryStockRequest";
import { ArticleAmountItem } from "../../Selects/ArticlesAmountSelect/ArticlesAmountSelectProperties";
import ArticleStockRequest from "../../../model/transaction/ArticleStockRequest";

class AddArticleStockStore {

    public articles: ArticleAmountItem[] = [];
    public entityId: string;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    public comment?: string;

    public success?: string;

    constructor(commonStore: CommonStore, entityId: string, selectedArticle?: Article) {
        this.entityId = entityId;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        if (selectedArticle) {
            this.addArticleItem(selectedArticle)
        } else {
            this.articles = [];
        }
        makeAutoObservable(this);
    }

    get enableButton(): boolean {
        return !!(this.articles.every(item => item.article && item.amount && item.amount !== 0));
    }

    @action
    public addArticleItem(article?: Article) {
        const newItem: ArticleAmountItem = {
            id: `${Date.now()}-${Math.random()}`,
            article: article,
            amount: undefined,
            articleError: undefined,
            amountError: undefined
        };
        this.articles.push(newItem);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        if (this.articles.length === 0) {
            this.addArticleItem();
        }
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        let response: Response<any>;
        const articles = this.articles
            .filter(article => article && article.article && article.amount && article.amount !== 0)
            .map(article => {
                return new ArticleStockRequest(
                    article.article!!.id,
                    article.amount!!
                )
            })
        const request = new AddArticleDeliveryStockRequest(this.entityId, articles, this.comment);
        response = await ArticleStockService.addArticleStock(request);
        this.commonStore.processErrors(response);
        this.loading = false;
        return response.success;
    }

}

export default AddArticleStockStore;